module.exports = __webpack_public_path__ + "img/img_13.39e64b80.jpg";